module.exports = __webpack_public_path__ + "312b6737b62474dd76c731c3f89a90e7.png";